// extracted by mini-css-extract-plugin
export default {"packages":"SelectPackage_packages__5saGi"};